import { createAsyncThunk } from '@reduxjs/toolkit';

const getProjects = async (
  { filters = {}, sortOption = {}, page = {}, searchTerm },
  { extra: { http } }
) => {
  try {
    const { projectFilter, talentPool, createdBy, clientCompany } = filters; // eslint-disable-line no-unused-vars
    const { element, order } = sortOption;
    const { number } = page;

    const params = {
      limit: 20,
      page: 1,
      sort_element: 'created_at',
      sort_order: 'desc',
    };

    if (number) {
      params.page = number + 1;
    }

    if (searchTerm?.length) {
      params.name = searchTerm;
    }

    if (element && order) {
      params.sort_by = element;
      params.sort_order = order;
    }

    if (projectFilter === 'all') {
      params.filter = '';
    } else {
      params.filter = projectFilter;
    }

    if (createdBy?.length) {
      params.created_by = createdBy;
    }

    if (talentPool?.length) {
      const talentPoolIds = talentPool?.map((talentPool) => talentPool?.id);
      params.talent_pool = talentPoolIds;
    }
    if (clientCompany?.length) {
      const clientCompanyIds = clientCompany?.map(
        (clientCompany) => clientCompany?.id
      );
      params.project_client = clientCompanyIds;
    }

    const projects = await http.get(`/projects`, { params });
    return projects;
  } catch {}
};

export const fetchProjects = createAsyncThunk('projects/fetch', getProjects);
